/*
 * url 请求接口
 * billType 单据类型
 * billNos array 单号数组
 * templateId 打印模板id， 可缺省
 * 
 */
// 销售订单 "/erpnew/account/c/reada46ceb/printsetCustomized/orderManagementPrintset"
// 出库单 /erpnew/account/c/reada46ceb/printsetCustomized/marketPrintset
/**
 * params: {
 *  url
 *  billType
 *  billNos
 *  sourceBillNos
 *  templateId
 *  callback
 * }
 */
import { newPost } from '@/assets/js/common.js'

// async function printSalOrder(url, billType, billNos, templateId, callback) {
export async function printSalOrder(params) {
  const ajaxParams = {
    billNos: params.billNos,
    billType: params.billType,
    id: params.templateId
  }
  console.log(ajaxParams)
  let url = ''
  if (params.billType == 'OI') {
    url = "/erpnew/account/c/reada46ceb/printsetCustomized/orderManagementPrintset"
  } else if (params.billType == 'SIN' || params.billType == 'HH' || params.billType == 'CHD') {
    url = "/erpnew/account/c/reada46ceb/printsetCustomized/marketPrintset"
  } else if (params.billType == 'CFY') {
    url = "/erpnew/account/c/reada46ceb/printsetCustomized/feePrint"
  } else if (params.billType == 'PIN') {
    url = "/erpnew/account/c/reada46ceb/printsetCustomized/purchaseStockPrintset"
  } else if (params.billType == 'PON') {
    url = "/erpnew/account/c/reada46ceb/printsetCustomized/purchaseReturnPrintset"
  } else if (params.billType == 'SON') {
    url = "/erpnew/account/c/reada46ceb/printsetCustomized/salReturnExPrintset"
  } else if (params.billType == 'CK') {
    url = ""
  } else if (params.billType == 'SKDN') {
    url = "/erpnew/account/c/reada46ceb/printsetCustomized/printArrears"
  } else if (params.billType == 'SKD') {
    url = "/erpnew/account/c/reada46ceb/printsetCustomized/printPrePay"
  } else if (params.billType == 'MV') {
    url = "/erpnew/account/c/reada46ceb/printsetCustomized/InvMovePrintset"
  } else if (params.billType == 'OO') {
    url = "/erpnew/account/c/reada46ceb/printsetCustomized/salOrderReturnPrintset"
  } else if (params.billType == 'HHD') {
    url = "/erpnew/account/c/reada46ceb/printsetCustomized/purchasingOrderPrintset"
  } else if (params.billType == 'EHD') {
    url = "/erpnew/account/c/reada46ceb/printsetCustomized/printExchangeSalOrderBatch"
  } else if (params.billType == 'DH') {
    url = "/erpnew/account/c/reada46ceb/printsetCustomized/salOrderMeetNewPrintset"
  }

  const { data: res } = await newPost(url, ajaxParams)
  if (!res || res.code != '0') {
    params.callback && params.callback()
    if (res.message) {
      // showMessage('提示', res.message)
      showLodopMessage(res.message)
    }
    return
  }

  //右下角弹出 普通显示
  function showMessage(title, msg) {
    $.messager.show({
      title: title,
      msg: msg,
      showType: 'show'
    });
  }
  const bodyStyle = "<style>.table thead > tr:not(.noSetHeight) th:not(.headclass),.table tbody > tr td,.table tfoot > tr:not(.noSetHeight) td:not(.footclass) {box-sizing: border-box;padding: 2px 4px;} .table,.table th{border:none;} .table td{border: 1px solid #000;}</style>"
  const headStyle = "<style>.tempPrintBox p,.tempPrintBox h1,.tempPrintBox h2,.tempPrintBox h3,.tempPrintBox h4,.tempPrintBox h5,.tempPrintBox h6, .print-box p,.print-box h1,.print-box h2,.print-box h3,.print-box h4,.print-box h5,.print-box h6{margin: 2px 0;}.tempPrintBox .print-flex-item, .print-box .print-flex-item{border: none !important;word-break: break-all;</style>"
  // 拿到模板转换后的实际html 及 相关参数
  // 把html插入到document中
  $(document.body).append(`<div class="tempPrintBox" style="width: 820px;height: 1px;overflow:hidden;">` + bodyStyle + headStyle + res.data.printTemplate + `</div>`)
  /**
   * height 纸张高度
   * width 纸张宽度
   * printSetType 打印类型
   * printTemplate 转换后的打印模板
   * qrCode 二维码位置
   *
   */
  const controlFrom = {
    paperWidth: res.data.width, // 纸张宽度
    paperHeight: res.data.height, // 纸张高度
    marginTop: res.data.printLodopMarginTop, // 上边距
    marginLeft: res.data.printLodopMarginLeft, // 左边距
    module: res.data.isPrintPage === 'Y' ? 1 : 3, // 打印模式 1分页打印 3即打即停
    isHead: res.data.isPrintHead === 'Y', // 每页是否打印表头
    isFooter: res.data.isPrintFooter === 'Y', // 每页是否打印表尾
    bottomWhite: res.data.bottomLodopHeight, // 即打即停留白
    tableHeight: 30, // 表格高度
    isPrintPagesNumber: res.data.isPrintPagesNumber === 'Y', //是否打印页码
    // titleSize: 14, // 标题字体大小
    contentSize: 14, // 内容字体大小
    billNos: params.billNos, // 单号
    billType: params.billType, // 单据类型
    sourceBillNos: params.sourceBillNos
  }

  printFn(controlFrom, bodyStyle, headStyle, params.callback)
}
function printFn(controlFrom, bodyStyle, headStyle, callback) {
  let LODOP
  let res = getLodop()
  if (res.status) {
    LODOP = res.data
  } else {
    showLodopMessage(res.message)
    callback && callback()
    return
  }
  // 1mm = 3.78px
  if (controlFrom.module == 1) {
    $('.tempPrintBox .main').each((index, item) => {
      $('.page-code').remove()
      let head = $(item).find('.tableHead').html() || '<span></span>'
      head = headStyle + '<div class="print-box" style="margin-right: ' + parseInt(controlFrom.marginLeft) * 3.78 + 'px;">' + head + '</div>'
      let tableStr = $(item).find('.tableBody').html()
      tableStr = '<div class="print-box" style="margin-right: ' + (parseInt(controlFrom.marginLeft) * 3.78 + 6) + 'px;">' + tableStr + '</div>'
      let table = bodyStyle + tableStr
      let footer = $(item).find('.tableFooter').html()
      footer = headStyle + '<div class="print-box" style="margin-right: ' + parseInt(controlFrom.marginLeft) * 3.78 + 'px;">' + footer + '</div>'
      let column = $(table).find('colgroup col').size()
      let div = document.createElement('div')
      let height = $(item).find('.tableHead').height() + 10   // 10 td tr 的border，内边距，p之类标签的margin
      $(div).append(table)
      if (controlFrom.isHead) {
        $(div).find('thead').prepend(`<tr style="height: ${height}px;"><td colspan="${column}" class='headclass' style='width: 100%; background-color: #fff; border: none;'>${head}</td></tr>`)
      } else {
        // 页面高度16 / 比例3.78 = 4.23
        let top = parseInt(controlFrom.marginTop)
        if (controlFrom.isPrintPagesNumber) {
          top = top + 4.23
        }
        LODOP.ADD_PRINT_HTM(top + 'mm', controlFrom.marginLeft + 'mm', "100%", "100%", head)
      }
      if (controlFrom.isFooter) {
        // 可能没有tfoot， 没有的话，加一行
        if ($(div).find('tfoot').length > 0) {
          $(div).find('tfoot').append(`<tr><td colspan="${column}" class='footclass' style='width: 100%; background-color: #fff; border: none;'>${footer}</td></tr>`)
        } else {
          $(div).find('table').append(`<tfoot><tr><td colspan="${column}" class='footclass' style='width: 100%; background-color: #fff; border: none;'>${footer}</td></tr></tfoot>`)
        }
      }
      if (controlFrom.isHead) {
        let top = parseInt(controlFrom.marginTop)
        if (controlFrom.isPrintPagesNumber) {
          top = top + 4.23
        }
        LODOP.ADD_PRINT_TABLE(top + 'mm', controlFrom.marginLeft + 'mm', "100%", "100%", $(div).html());
      } else {
        LODOP.ADD_PRINT_TABLE(0, 0, "100%", "100%", $(div).html());
        LODOP.SET_PRINT_STYLEA(0, "LinkedItem", -1);
      }
      if (!controlFrom.isFooter) {
        LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", footer)
        LODOP.SET_PRINT_STYLEA(0, "LinkedItem", -1);
      }
      if (controlFrom.isPrintPagesNumber) {
        LODOP.ADD_PRINT_HTM(parseInt(controlFrom.marginTop) + 'mm', 750, 300, 100, "<span tdata='pageNO'>##</span>/<span tdata='pageCount'>##</span>");
        LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);//每页都输出
      }

      LODOP.SET_PRINT_PAGESIZE(1, controlFrom.paperWidth + "mm", controlFrom.paperHeight + "mm", "");
      LODOP.NewPageA();
    })
  } else {
    let allData = bodyStyle
    $('.tempPrintBox .main').each((index, item) => {
      let head = $(item).find('.tableHead').html()
      head = headStyle + '<div class="print-box" style="margin-right: ' + parseInt(controlFrom.marginLeft) * 3.78 + 'px;">' + head + '</div>'
      let table = $(item).find('.tableBody').html()
      table = bodyStyle + '<div class="print-box" style="margin-right: ' + (parseInt(controlFrom.marginLeft) * 3.78 + 6) + 'px;">' + table + '</div>'
      let footer = $(item).find('.tableFooter').html()
      footer = headStyle + '<div class="print-box" style="margin-right: ' + parseInt(controlFrom.marginLeft) * 3.78 + 'px;">' + footer + '</div>'
      allData += head + table + footer
    })
    LODOP.ADD_PRINT_HTM(controlFrom.marginTop + 'mm', controlFrom.marginLeft + 'mm', "100%", "100%", allData)
    LODOP.SET_PRINT_PAGESIZE(3, controlFrom.paperWidth + "mm", controlFrom.bottomWhite + "mm", "");

  }
  if (LODOP.CVERSION) CLODOP.On_Return = (taskID, value) => {
    console.log('clodop return:', taskID, value)
    if (value > 0) {
      batchUpdateBillPrintCount(controlFrom, value)
    } else {
    }
    callback && callback()
    removeTempDom()
  }
  LODOP.SET_SHOW_MODE('PREVIEW_NO_MINIMIZE', true)
  LODOP.PREVIEW();
}
function batchUpdateBillPrintCount(controlFrom, value) {
  // const billNos = controlFrom.billNos.join(',')

  let params = {
    billNos: [],
    printCount: value
  }
  if (controlFrom.sourceBillNos && controlFrom.sourceBillNos.length) {
    const sourceBillNos = controlFrom.sourceBillNos.map(item => {
      return "'" + item + "'"
    }).join(',')
    params.billNos = sourceBillNos
  } else {
    const billNos = controlFrom.billNos.map(item => {
      return "'" + item + "'"
    }).join(',')
    params.billNos = billNos
  }

  $.post('/Account/PrintSet/updateSysCountPrint.html', params).then(res => {

  })
}
function removeTempDom() {
  let list = document.getElementsByClassName('tempPrintBox')
  for (let i = 0; i < list.length; i++) {
    list[i].remove()
  }
}
function showLodopMessage(html) {
  top.layer.open({
    type: 1,
    title: '提示',
    shadeClose: true,
    shade: 0.4,
    maxmin: true,
    fix: false,
    area: ['60%', '50%'],
    content: html
  });
}

const g_billTypeItem = {
  'XSDA': 'SIN',
  'XSDB': 'HH',
  'XSDC': 'CHD',
  'CGD': 'PIN',
  'FYD': 'CFY',
  'CGT': 'PON',
  'XSTXST': 'SON',
  'XSTCHD': 'CHD',
  'PKD': 'CK',
  'SKD': 'SKDN',
  'SKDA': 'SKD',
  'DBD': 'MV',
  'DHD': 'DH',
}

export function g_getValueByKey(key) {
  for (const [k, v] of Object.entries(g_billTypeItem)) {
    if (k === key) {
      return v;
    }
  }
  return null;
}

export function g_getKeyByValue(value, tag = '') {
  for (const [k, v] of Object.entries(g_billTypeItem)) {
    if (v === value && k.includes(tag)) {
      return k;
    }
  }
  return null;
}
